//In future or later with the current ticket, repalce this with typescript
import React from "react";
import useUser from "../../../../hooks/useUser";
import { GlobalDataContext } from "../../../../contexts/GlobalData";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import useSubmitBookingModal from "../../../../hooks/useSubmitBookingModal";
import { CREATE_APPOINTMENT_FOR_USER } from "../../../../enums/PermissionTitles";
import { useFetch } from "../../../../hooks/Fetching";

export const BookingContext = React.createContext();

export const AppointmentType = "priceList";
export default function BookingModalContext({ children }) {
  const user = useUser();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const selectedPetId = React.useRef(null);
  const workingDaysDto = useFetch(
    "/clinics/working_days/dto/",
    user?.currentClinic?.id,
    "working_days_dto",
    true,
    0
  );
  const workingDays = workingDaysDto?.data?.workingDays;

  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const permission = isPermissionAllowed(CREATE_APPOINTMENT_FOR_USER);
  const [newUserSelected, setNewUserSelected] = React.useState(false);
  const submittion = useSubmitBookingModal(selectedPetId.current);

  const submitData = async (appointment) => {
    submittion.submitCallback(appointment);
  };

  function getLoading() {
    return submittion.loading;
  }

  function isNewUserSelected() {
    return newUserSelected;
  }

  function toggleNewUserSelected() {
    setNewUserSelected((prev) => !prev);
  }

  const values = {
    isNewUserSelected,
    toggleNewUserSelected,
    workingDays,
    getLoading,
    submitData,
    user,
    submittion,
    handleSnackbar,
  };

  return (
    <BookingContext.Provider value={values}>{children}</BookingContext.Provider>
  );
}
